import {
  BusinessEntitlementConfig,
  EntitlementName,
} from "@shared/types/localTypes/entitlements.ts";

const entitlement: BusinessEntitlementConfig = {
  entitlementName: EntitlementName.BUSINESS_SECURITY_ADVANCED,
  displayName: "Business Security",
  isCustomerFacing: false,
};

export default entitlement;
